var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated"},[(_vm.submission_collection)?_c('SubmissionServerTable',{attrs:{"collection":_vm.submission_collection}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }